export interface IInputOption {
  label?: string;
  value: any;
  icon?: string;
  repeat?: number;
  disabled?: boolean;
  key?: string;
}
